import React from 'react';
//import Constants from '../Config/Config';

export const Loader = () => {
    return  <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>;
}

export const ErrorHandle = (props) => {
	const {errorText, error} = props;
	if(error){
	    return (
	        <div className="alert alert-danger">{errorText}</div>
	    );
	}
	return (null);
}

export function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

export function getCanvasData(matBoard) {
	const canvas = document.createElement('canvas');
	const context = canvas.getContext("2d");

	const canvasWidth = matBoard.getIn(['mat_size', 'width']);
	const canvasHeight = matBoard.getIn(['mat_size', 'height']);

	const q = Math.min(1e3 / canvasWidth, 1e3 / canvasHeight);

	canvas.width = canvasWidth * q;
	canvas.height = canvasHeight * q;

	context.save();
	context.fillStyle = "#E8E8E8";
	context.fillRect(0, 0, canvas.width, canvas.height);

	for (let z = 0; z < matBoard.get('mat_data').size; z++) {
		const windowsCanvas = document.createElement('canvas');
		const windowsCanvasCtx = windowsCanvas.getContext('2d');

		const sizeWidth = matBoard.getIn(['mat_data', z, 'width']) * q
    	const sizeHeight = matBoard.getIn(['mat_data', z, 'height']) * q
    	const sizeX = matBoard.getIn(['mat_data', z, 'x']) * q
    	const sizeY = matBoard.getIn(['mat_data', z, 'y']) * q

		windowsCanvas.width = sizeWidth;
		windowsCanvas.height = sizeHeight;

	    //console.log(windowsCanvas.toDataURL());

		windowsCanvasCtx.save();
		windowsCanvasCtx.fillStyle = "#fff";
	    windowsCanvasCtx.fillRect(0, 0, windowsCanvas.width, windowsCanvas.height);

		windowsCanvasCtx.strokeStyle = "#D3D3D3";
		windowsCanvasCtx.lineWidth   = 10;
		windowsCanvasCtx.strokeRect(0, 0, windowsCanvas.width, windowsCanvas.height);

		windowsCanvasCtx.shadowBlur = 20;
		windowsCanvasCtx.shadowOffsetX = 0;
		windowsCanvasCtx.shadowOffsetY = 0;
		windowsCanvasCtx.shadowColor = 'rgba(68,68,68,0.5)';
		windowsCanvasCtx.lineWidth = 15;
		var ja = windowsCanvasCtx.lineWidth / 2;
		windowsCanvasCtx.strokeRect(0 - ja, 0 - ja, windowsCanvas.width + 2 * ja, windowsCanvas.height + 2 * ja);
		windowsCanvasCtx.restore();

		context.drawImage(windowsCanvas, 0, 0, windowsCanvas.width, windowsCanvas.height, sizeX, sizeY, windowsCanvas.width, windowsCanvas.height);
	}

	// Plauqe
	if (matBoard.get('has_plaque') === 'yes') {
		context.save();
		context.fillStyle = "#FFDF00";
	    context.fillRect(parseFloat(matBoard.getIn(['plaque_large', 'x'])) * q, parseFloat(matBoard.getIn(['plaque_large', 'y'])) * q, parseFloat(matBoard.getIn(['plaque_large', 'width'])) * q, parseFloat(matBoard.getIn(['plaque_large', 'height'])) * q);
	}

	return canvas.toDataURL();
}

export const CheckBox = props => {
    return (
		<li className="checkboxWrapper">
			<label className={props.isChecked ? 'active btn' : 'btn'}>
				<input key={props.id} name={props.value} onClick={props.handleCheckChieldElement} type="checkbox" checked={props.isChecked} value={props.value} /> <i className={'fa fa-'+props.value}></i>
			</label>
		</li>
    )
}

export const Radio = props => {
    return (
		<li className="radioWrapper">
			<label className={props.colour === props.value ? 'active btn' : 'btn'}>
				<span style={{backgroundColor: props.value}}></span>
				<input key={props.id} name="color" onChange={props.handleCheckChildElement} type="radio" checked={props.colour === props.value} value={props.value} /> {props.name}
			</label>
		</li>
    )
}

export const RadioSize = props => {
	let plaqueParameter = '';
	switch (props.name) {
		case 'small':
			plaqueParameter = 'plaque_data'
			break;
		case 'medium':
			plaqueParameter = 'plaque_medium'
			break;
		case 'large':
			plaqueParameter = 'plaque_large'
			break;
		default:
	}

	const pWidth = parseFloat(props.selectedmatBoard.getIn([plaqueParameter, 'width']));
	const pHeight = parseFloat(props.selectedmatBoard.getIn([plaqueParameter, 'height']));

    return (
		<li className="radioWrapper">
			<label className={props.plaqueSize === props.name ? 'active btn' : 'btn'}>
				<input key={props.id} name="plaqueSize" onChange={props.handleCheckChildElement} type="radio" checked={props.plaqueSize === props.name} value={props.name} /> {props.name} <br /> ({pWidth} x {pHeight} cm)
			</label>
		</li>
    )
}

export const getPlaqueLength = props => {
	if (props.size > 0) {
		var totalString = '';
		for (var i = 0; i < props.size; i++) {
			totalString += props.getIn([i, 'text']);
		}
		return parseInt(totalString.trim().length)
	}
	return 0;
}

export const getPlaqueSize = props => {
	const plaqueSize = props;
	let plaqueParameter = '';
	switch (plaqueSize) {
		case 'small':
			plaqueParameter = 'plaque_data'
			break;
		case 'medium':
			plaqueParameter = 'plaque_medium'
			break;
		case 'large':
			plaqueParameter = 'plaque_large'
			break;
		default:
	}
	return plaqueParameter;
}